import React from 'react';
import { Modal } from 'reactstrap';
import PropTypes from 'prop-types';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func,
  modalClass: PropTypes.string,
  className: PropTypes.string,
  modalType: PropTypes.string,
  children: PropTypes.node
};

const defaultProps = {
  isOpen: false,
  modalClass: 'primary',
  className: '',
  modalType: ''
};

class ModalWrapper extends React.Component {
  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = e => {
    const { isOpen, toggleModal } = this.props;
    if (e.key === 'Escape') {
      if (isOpen) {
        toggleModal();
      }
    }
  };

  render() {
    const { isOpen, toggleModal, modalClass, children } = this.props;
    let { className } = this.props;
    let { modalType } = this.props;
    const isPrimary = modalClass.indexOf('primary') !== -1;

    className += isPrimary
      ? modalType === 'IMPORT_SUMMARY'
        ? 'modal-wrapper mdl-wpr-ext-width'
        : 'modal-wrapper'
      : '';

    return (
      <Modal
        isOpen={isOpen}
        toggle={toggleModal}
        className={`modal-${modalClass} ${className}`}
        centered={!isPrimary}
        fade={true}
      >
        {children}
      </Modal>
    );
  }
}

ModalWrapper.propTypes = propTypes;
ModalWrapper.defaultProps = defaultProps;
export default ModalWrapper;
